import { render } from "./RoleAllocationSetting.vue?vue&type=template&id=dd54325a"
import script from "./RoleAllocationSetting.vue?vue&type=script&lang=js"
export * from "./RoleAllocationSetting.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./RoleAllocationSetting.vue?vue&type=style&index=1&id=dd54325a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__